import React, { useEffect, useRef, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSeedling,
  faHandHoldingUsd,
  faUser,
  faCheckCircle,
  faFileContract,
  faEye,
  faUniversity,
  faSave,
  faImage,
} from "@fortawesome/free-solid-svg-icons";

import useFetch from "../../../../hooks/useFetch";
// import ImageUploader from "../../components/ImageUploader";
// import ProfilePicHandle from "../components/ProfilePicHandle";
import WebpImgUploader from "../components/WebpImgUploader";


const FoundHerMySupportProfile = () => {
  const authState = useSelector((state) => state.authReducer);
  const [fetchData] = useFetch();
  const userId = authState?.user?._id;
  const userCode = authState?.user?.think5whyscode;
  const userName = authState?.user?.name;

  const token = authState?.token;
  const hasFetchedRef = useRef(false);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState("");

  const [isExistingProfile, setIsExistingProfile] = useState(false);
  const [successMsg, setSuccessMsg] = useState("");
  const [supporterMessage, setSupporterMessage] = useState("");
  const [showSupporterList, setShowSupporterList] = useState(true);
  const [supporters, setSupporters] = useState([]);
  const [collegeBadge, setCollegeBadge] = useState(null);
  const [isApplyingForBadge, setIsApplyingForBadge] = useState(false);
  // const [isClickToUpload, setIsClickToUpload] = useState(false);
  const [profileImageError, setProfileImageError] = useState(false);
  const [showUploader, setShowUploader] = useState(false);

  const [form, setForm] = useState({
    userId: authState?.user?._id,
    userCode: authState?.user?.think5whyscode,
    userName: authState?.user?.name,

    profilePhoto: "",
    coverPhoto: "",

    headline: "",
    missionTagline: "",
    supportStory: "",

    location: "",
    mobile: "",
    whatsapp: "",
    email:"",

    currentStage: "",
    currentNeed: "",

    collegeVerified: false,
    collegeName: "",
    collegeCode: "",

    fundraisingGoal: 0,
    raisedAmount: 0,

    supportNeeds: [],

    hasInnovationHub: false,
    hasBrandStore: false,
    isSpotlighted: false,

    collegeBadge: {},
  });

  const [supporterForm, setSupporterForm] = useState({
    supporterCode: "",
    supporterName: "",
    supportType: "Money",
    supportItem: "",
  });

  const supportTypes = [
    "Money",
    "PreOrder",
    "Furniture",
    "Fixtures",
    "Machinery",
    "Rental",
    "Professional",
    "Mentorship",
    "MarketAccess",
    "Volunteer",
    "Other",
  ];

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const supportOptions = [
    "Money",
    "PreOrder",
    "Furniture",
    "Fixtures",
    "Machinery",
    "Rental",
    "Professional",
    "Mentorship",
    "MarketAccess",
    "Volunteer",
    "Other",
  ];

  const [isEditing, setIsEditing] = useState(false);
  const [deleteConfirmId, setDeleteConfirmId] = useState(null);

  const toggleSupportNeed = (type) => {
    setForm((prev) => {
      const exists = prev.supportNeeds.some((s) => s?.type === type);

      if (exists) {
        return {
          ...prev,
          supportNeeds: prev.supportNeeds.filter((s) => s?.type !== type),
        };
      } else {
        return {
          ...prev,
          supportNeeds: [
            ...prev.supportNeeds,
            {
              type,
              title: "",
              description: "",
              needed: 1,
              received: 0,
              enabled: true,
            },
          ],
        };
      }
    });
  };

  const fetchMySupportProfile = async () => {
    if (hasFetchedRef.current) return;

    try {
      setLoading(true);

      const config = {
        url: "/foundher/support-profile/my",
        method: "post",
        data: { userId, userCode, userName},
        headers: { Authorization: token },
      };

      const response = await fetchData(config, { silent: true });
// console.log("Foundher Support Profile: ",response);
      if (response?.status && response.record) {
        setForm(response.record);
        setIsExistingProfile(true);
        hasFetchedRef.current = true;
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!userId) return;

    fetchMySupportProfile();
    fetchSupporters();
    fetchCollegeBadge();
  }, [userId]);

  const saveProfile = async () => {
    if (!form.headline.trim()) {
      setMessage("Headline is required.");
      return;
    }

    if (!form.supportStory.trim()) {
      setMessage("Please tell your story.");
      return;
    }

    if (!form.currentNeed.trim()) {
      setMessage("Current Need is required.");
      return;
    }

    if (!form.fundraisingGoal) {
      setMessage("Fund Raising Goal is required.");
      return;
    }

    try {
      setSaving(true);
      setMessage("");

      const config = {
        url: "/foundher/support-profile/save",
        method: "post",
        headers: {
          Authorization: token,
        },
        data: { ...form, supportNeeds: form.supportNeeds },
      };

      const response = await fetchData(config);

      if (response?.status) {
        setMessage("Profile saved successfully.");

        hasFetchedRef.current = false;

        fetchMySupportProfile();
      } else {
        setMessage(response?.message);
      }
    } catch (err) {
      console.log(err);

      setMessage("Unable to save profile.");
    } finally {
      setSaving(false);
    }
  };

  const getProfileCompletion = () => {
    let score = 0;

    if (form.profilePhoto) score += 10;
    if (form.coverPhoto) score += 10;

    if (form.headline) score += 10;
    if (form.missionTagline) score += 10;
    if (form.supportStory) score += 15;

    if (form.currentNeed) score += 10;
    if (form.currentStage) score += 10;
    if (form.fundraisingGoal > 0) score += 10;

    if (form.supportNeeds?.length) score += 10;

    if (supporters?.length) score += 5;

    return score;
  };

  const completion = getProfileCompletion();

  const fetchCollegeBadge = async () => {
    try {
      const config = {
        url: "/foundher/college-badge/my", // create this route later
        method: "post",
        headers: { Authorization: token },
        data: { founderId: userId },
      };

      const response = await fetchData(config, { silent: true });

      if (response?.status) {
        setCollegeBadge(response.record);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const applyForBadge = async () => {
    if (!form.collegeName?.trim()) {
      setMessage("Institution Name is required.");
      return;
    }

    try {
      const config = {
        url: "/foundher/college-badge/apply",
        method: "post",
        headers: { Authorization: token },
        data: {
          userId,
          userCode,
          userName,
          institutionName: form.collegeName,
          institutionType: form.institutionType || "College",
          city: form.location || "",
          institutionCode: form.collegeCode,
        },
      };

      const response = await fetchData(config);

      if (response?.status) {
        setMessage("✅ Application submitted successfully!");
        setTimeout(() => setMessage(""), 4000);
        fetchCollegeBadge();
      } else {
        setMessage(response?.message || "Failed to submit application.");
      }
    } catch (err) {
      console.error("Apply Badge Error:", err);
      setMessage("Error submitting application.");
    }
  };

  const handleSupporterChange = (e) => {
    const { name, value } = e.target;

    setSupporterForm({
      ...supporterForm,
      [name]: value,
    });
  };

  const resetSupporterForm = () => {
    setSupporterForm({
      supporterCode: "",
      supporterName: "",
      supportType: "Money",
      supportItem: "",
    });
    setIsEditing(false);
  };

  const editSupporter = (item) => {
    setSupporterForm({
      id: item._id, // Important for update
      supporterCode: item.supporterCode || "",
      supporterName: item.supporterName || "",
      supportType: item.supportType || "Money",
      supportItem: item.supportItem || "",
    });
    setIsEditing(true);
  };

  const fetchSupporters = async () => {
    try {
      const config = {
        url: "/foundher/supporters",
        method: "post",
        headers: { Authorization: token },
        data: { founderId: userId || form.userId },
      };

      const response = await fetchData(config, { silent: true });

      if (response?.status) {
        setSupporters(response.records || []);
        // fetchSupporters();
      }
    } catch (err) {
      console.log(err);
    }
  };

  const addSupporter = async () => {
    if (!supporterForm.supporterName?.trim()) {
      setSupporterMessage("Supporter Name is required.");
      return;
    }

    try {
      const config = {
        url: "/foundher/supporter/add",
        method: "post",
        headers: { Authorization: token },
        data: {
          founderId: form.userId,
          ...supporterForm,
        },
      };

      const response = await fetchData(config);

      if (response?.status) {
        setSupporterMessage("✅ Supporter added successfully!");
        setTimeout(() => setSupporterMessage(""), 4000);

        hasFetchedRef.current = false;
        // fetchMySupportProfile();
        resetSupporterForm();
        fetchSupporters();
      } else {
        setSupporterMessage(response?.message || "Failed to add supporter.");
      }
    } catch (err) {
      console.log(err);
      setSupporterMessage("❌ Error adding supporter.");
    }
  };

  const updateSupporter = async () => {
    if (!supporterForm.supporterName?.trim()) {
      setSupporterMessage("Supporter Name is required.");
      return;
    }

    try {
      const config = {
        url: "/foundher/supporter/update",
        method: "put",
        headers: { Authorization: token },
        data: supporterForm,
      };

      const response = await fetchData(config);

      if (response?.status) {
        setSupporterMessage("✅ Supporter updated successfully!");
        setTimeout(() => setSupporterMessage(""), 4000);

        hasFetchedRef.current = false;
        fetchSupporters();
        // fetchMySupportProfile();
        resetSupporterForm();
      } else {
        setSupporterMessage(response?.message || "Failed to update supporter.");
      }
    } catch (err) {
      console.log(err);
      setSupporterMessage("❌ Error updating supporter.");
    }
  };

  const deleteSupporter = async (supporterId) => {
    if (deleteConfirmId === supporterId) {
      // Confirmed - proceed with delete
      try {
        const config = {
          url: "/foundher/supporter/delete",
          method: "delete",
          headers: { Authorization: token },
          data: { id: supporterId }, // Important: send as 'id'
        };

        const response = await fetchData(config);

        if (response?.status) {
          setSupporterMessage("✅ Supporter deleted successfully.");
          setTimeout(() => setSupporterMessage(""), 4000);

          hasFetchedRef.current = false;
          //   fetchMySupportProfile();
          fetchSupporters();
        } else {
          setSupporterMessage(
            "⚠️ " + (response?.message || "Failed to delete."),
          );
        }
      } catch (err) {
        console.log(err);
        setSupporterMessage("❌ Error deleting supporter.");
      } finally {
        setDeleteConfirmId(null);
      }
    } else {
      // First click - show confirmation
      setDeleteConfirmId(supporterId);
      setSupporterMessage("⚠️ Click Delete again to confirm.");
    }
  };

  return (
    <div className="max-w-5xl mx-auto p-6 bg-black text-white min-h-screen">
      <h1 className="flex flex-col text-lg lg:text-2xl font-bold bg-pink-700 px-4 py-2 rounded-lg text-pink-100 items-center gap-2 mb-2">
        <FontAwesomeIcon icon={faSeedling} /> My SupportAFoundHer Profile
      </h1>

      <div className="mb-5">
        <div className="flex justify-between text-xs font-semibold mb-1">
          <span>Profile Completion</span>

          <span>{completion}%</span>
        </div>

        <div className="w-full h-3 bg-gray-200 rounded-full">
          <div
            className="bg-pink-700 h-3 rounded-full transition-all"
            style={{ width: `${completion}%` }}
          />
        </div>

        {completion < 100 && (
          <p className="text-xs text-orange-600 mt-2">
            Complete your profile to inspire more supporters.
          </p>
        )}
      </div>
      <div className="bg-zinc-800 rounded-xl shadow p-5 text-gray-100">
        <h2 className="text-xl font-bold text-pink-700 mb-4 flex items-center gap-2">
          <FontAwesomeIcon icon={faSeedling} />
          My Support Profile {profileImageError}
        </h2>
        <div className="flex flex-col gap-6 items-start">
          <div className="text-sm lg:text-lg font-semibold text-cyan-200">
            Your Profile Photo
          </div>
          <div className="flex flex-col items-center">
            {!profileImageError ? (
              <img
                src={`/api/downloads/users/profilepic/${userCode}.webp?t=${Date.now()}`}
                alt=""
                onClick={() => setShowUploader(true)}
                onError={(e) => {
                  e.currentTarget.style.display = "none";
                  setProfileImageError(true);
                }}
                onLoad={() => setProfileImageError(false)}
                className="w-28 h-28 rounded-full border-4 border-white object-cover"
              />
            ) : (
              <div
                onClick={() => setShowUploader(true)}
                className="w-28 h-28 rounded-full bg-white border-4 border-white flex 
                        items-center justify-center text-gray-500 text-4xl"
              >
                👤
              </div>
            )}
            <button
              type="button"
              onClick={() => setShowUploader(true)}
              className="absolute bottom-0 right-0 w-8 h-8 rounded-full bg-pink-600 hover:bg-pink-700 text-white border-2 border-white"
            >
              ✏️
            </button>
          </div>

          {showUploader && (
            <WebpImgUploader
              label="Change Profile Photo"
              value={`/api/downloads/users/profilepic/${userCode}.webp`}
              rounded={true}
              uploadType="profile"
              uploadUrl="/upload-profilepic"
              token={token}
              maxSizeKB={100}
              showWebpHelp={true}
              onChange={(filename, displayUrl) => {
                setProfileImageError(false);
                setForm((prev) => ({
                  ...prev,
                  profilePhoto: filename,
                }));
              }}
              onClose={() => setShowUploader(false)}
            />
          )}
        </div>

        {/* <ProfilePicHandle
          value={form.profilePhoto}
          userCode={form.userCode}
          token={token}
          onChange={(url) => setForm({ ...form, profilePhoto: url })}
        /> */}
        {/* <WebpImgUploader
          label="Cover Photo"
          value={form.coverPhoto}
          rounded={false}
          uploadType="foundhercover"
          uploadUrl="/upload-foundhercoverphoto"
          token={token}
          maxSizeKB={300}
          showWebpHelp={true}
          onChange={(filename, displayUrl) =>
            setForm({
              ...form,
              coverPhoto: displayUrl,
            })
          }
        /> */}

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <label className="text-xs font-semibold">Headline</label>
            <input
              name="headline"
              value={form.headline}
              onChange={handleChange}
              className="w-full border rounded-lg p-2 mt-1 bg-zinc-700"
            />
          </div>

          <div>
            <label className="text-xs font-semibold">Mission Tagline</label>
            <input
              name="missionTagline"
              value={form.missionTagline}
              onChange={handleChange}
              className="w-full border rounded-lg p-2 mt-1 bg-zinc-700"
            />
          </div>

          <div className="md:col-span-2">
            <label className="text-xs font-semibold">My Story</label>
            <textarea
              style={{ height: "250px" }}
              name="supportStory"
              value={form.supportStory}
              onChange={handleChange}
              className="w-full border rounded-lg p-2 mt-1"
            />
          </div>

          <div>
            <label className="text-xs font-semibold">Location</label>
            <input
              name="location"
              value={form.location}
              onChange={handleChange}
              className="w-full border rounded-lg p-2 mt-1 bg-zinc-700"
            />
          </div>

          <div>
            <label className="text-xs font-semibold">Mobile</label>
            <input
              name="mobile"
              value={form.mobile}
              onChange={handleChange}
              className="w-full border rounded-lg p-2 mt-1 bg-zinc-700"
            />
          </div>

          <div>
            <label className="text-xs font-semibold">WhatsApp</label>
            <input
              name="whatsapp"
              value={form.whatsapp}
              onChange={handleChange}
              className="w-full border rounded-lg p-2 mt-1 bg-zinc-700"
            />
          </div>

          <div>
            <label className="text-xs font-semibold">Email</label>
            <input
              name="email"
              value={form.email}
              onChange={handleChange}
              className="w-full border rounded-lg p-2 mt-1 bg-zinc-700"
            />
          </div>

          <div>
            <label className="text-xs font-semibold">Current Stage</label>
            <select
              name="currentStage"
              value={form.currentStage}
              onChange={handleChange}
              className="w-full border rounded-lg px-2 py-1 mt-1 bg-zinc-700"
            >
              <option value="Idea">Select Stage</option>
              {["Idea", "Prototype", "MVP", "Pilot", "Revenue", "Growth"].map(
                (stage) => (
                  <option key={stage} value={stage}>
                    {stage}
                  </option>
                ),
              )}
            </select>
          </div>

          <div>
            <label className="text-xs font-semibold">Current Need</label>
            <input
              name="currentNeed"
              value={form.currentNeed}
              onChange={handleChange}
              className="w-full border rounded-lg p-2 mt-1 bg-zinc-700"
            />
          </div>

          <div>
            <label className="text-xs font-semibold">
              Fund Raising Goal (₹)
            </label>
            <input
              type="number"
              name="fundraisingGoal"
              value={form.fundraisingGoal}
              onChange={handleChange}
              className="w-full border rounded-lg p-2 mt-1 bg-zinc-700"
            />
          </div>

          <div>
            <label className="text-xs font-semibold">Raised Amount (₹)</label>
            <input
              type="number"
              name="raisedAmount"
              value={form.raisedAmount}
              onChange={handleChange}
              className="w-full border rounded-lg p-2 mt-1 bg-zinc-700"
            />
          </div>

          <div className="mt-8 border-t pt-5">
            <div className="flex items-center justify-between mb-4">
              <h3 className="font-bold text-pink-700">
                Manage Supporters (Gratitude Wall)
                <span className="text-sm font-normal text-gray-400 ml-2">
                  ({supporters?.length || 0})
                </span>
              </h3>

              <button
                onClick={() => setShowSupporterList(!showSupporterList)}
                className="text-sm px-4 py-1 border border-zinc-600 hover:bg-zinc-800 rounded-lg transition"
              >
                {showSupporterList ? "Hide List" : "View List"}
              </button>
            </div>

            {supporterMessage && (
              <div
                className={`mb-4 p-3 rounded-lg text-sm ${
                  supporterMessage.includes("success")
                    ? "bg-green-900/30 border border-green-500 text-green-400"
                    : "bg-red-900/30 border border-red-500 text-red-400"
                }`}
              >
                {supporterMessage}
              </div>
            )}

            {/* Add / Edit Form */}
            <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-5 mb-6">
              <h4 className="text-sm font-semibold mb-4 text-pink-400">
                {supporterForm.supporterCode
                  ? "Edit Supporter"
                  : "Add New Supporter"}
              </h4>

              <div className="grid md:grid-cols-3 gap-4">
                <input
                  name="supporterCode"
                  placeholder="Supporter Code (Optional)"
                  value={supporterForm.supporterCode}
                  onChange={handleSupporterChange}
                  className="border border-zinc-700 rounded-lg p-3 bg-zinc-800"
                />

                <input
                  name="supporterName"
                  placeholder="Supporter Name *"
                  value={supporterForm.supporterName}
                  onChange={handleSupporterChange}
                  className="border border-zinc-700 rounded-lg p-3 bg-zinc-800"
                  required
                />

                <select
                  name="supportType"
                  value={supporterForm.supportType}
                  onChange={handleSupporterChange}
                  className="border border-zinc-700 rounded-lg px-2 py-1 bg-zinc-800"
                >
                  {supportTypes.map((x) => (
                    <option key={x} value={x}>
                      {x}
                    </option>
                  ))}
                </select>

                <input
                  name="supportItem"
                  placeholder="Support Item (Optional)"
                  value={supporterForm.supportItem}
                  onChange={handleSupporterChange}
                  className="md:col-span-3 border border-zinc-700 rounded-lg p-3 bg-zinc-800"
                />
              </div>

              <div className="mt-5 flex gap-3">
                <button
                  onClick={isEditing ? updateSupporter : addSupporter}
                  disabled={!supporterForm.supporterName?.trim()}
                  className="bg-pink-700 hover:bg-pink-600 disabled:bg-gray-600 px-6 py-2.5 rounded-lg transition flex-1 md:flex-none"
                >
                  {isEditing ? "Update Supporter" : "Add Supporter"}
                </button>

                {isEditing && (
                  <button
                    onClick={resetSupporterForm}
                    className="border border-zinc-600 hover:bg-zinc-800 px-5 py-2.5 rounded-lg transition"
                  >
                    Cancel
                  </button>
                )}
              </div>
            </div>

            {showSupporterList && (
              <div className="space-y-3">
                {supporters.length > 0 ? (
                  supporters.map((item) => (
                    <div
                      key={item._id}
                      className="border border-zinc-700 bg-zinc-900 rounded-xl p-5 flex flex-col sm:flex-row sm:items-center justify-between gap-4"
                    >
                      <div>
                        <div className="font-semibold text-lg">
                          {item.supporterName}
                        </div>
                        {item.supporterCode && (
                          <div className="text-sm text-gray-400">
                            Code: {item.supporterCode}
                          </div>
                        )}
                        <div className="text-pink-400 font-medium">
                          {item.supportType}
                        </div>
                        {item.supportItem && (
                          <div className="text-sm text-gray-400 mt-1">
                            {item.supportItem}
                          </div>
                        )}
                      </div>

                      <div className="flex gap-3">
                        <button
                          onClick={() => editSupporter(item)}
                          className="text-blue-400 hover:text-blue-300 px-4 py-2 text-sm border border-blue-900 hover:border-blue-700 rounded-lg transition"
                        >
                          Edit
                        </button>
                        <button
                          onClick={() => deleteSupporter(item._id)}
                          className={`px-4 py-2 text-sm rounded-lg transition border ${deleteConfirmId === item._id ? "bg-red-600 text-white border-red-600" : "text-red-400 hover:text-red-300 border-red-900 hover:border-red-700"}`}
                        >
                          {deleteConfirmId === item._id
                            ? "Confirm Delete"
                            : "Delete"}
                        </button>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-gray-500 text-center py-10 border border-dashed border-zinc-700 rounded-xl">
                    No supporters added yet.
                  </p>
                )}
              </div>
            )}
          </div>

          <div className="md:col-span-2 mt-3">
            <label className="text-sm lg:text-lg text-cyan-200 font-semibold mb-2 block">
              Looking For Support On
            </label>

            <div className="flex flex-row flex-wrap gap-2">
              {supportOptions.map((item) => {
                // Check if this type exists in the array of objects
                const isSelected = form.supportNeeds.some(
                  (need) => need?.type === item,
                );

                return (
                  <button
                    type="button"
                    key={item}
                    onClick={() => toggleSupportNeed(item)}
                    className={`w-fit px-3 py-2 rounded-full text-xs border transition ${
                      isSelected
                        ? "bg-pink-700 text-white border-pink-700"
                        : "bg-white text-gray-700 border-gray-300"
                    }`}
                  >
                    {item}
                  </button>
                );
              })}
            </div>
          </div>
        </div>

        <div className="mt-8 border-t pt-6">
          <h3 className="font-bold text-pink-700 mb-4 flex items-center gap-2">
            <FontAwesomeIcon icon={faUniversity} />
            College / NGO Women Cell Verification
          </h3>

          {form.collegeVerified && (
            <div className="mt-5 rounded-2xl border border-pink-500/40 bg-gradient-to-r from-pink-900/20 via-zinc-900 to-purple-900/20 p-5 shadow-lg">
              <div className="flex flex-col items-start gap-4">
                <div className="text-4xl">🎓✨</div>

                <div className="flex-1">
                  <div className="flex flex-wrap items-center gap-2">
                    <span className="px-3 py-1 rounded-full bg-green-500/20 text-green-300 text-xs font-bold tracking-wide">
                      ✅ VERIFIED FOUNDER
                    </span>

                    <span className="px-3 py-1 rounded-full bg-pink-500/20 text-pink-300 text-xs font-semibold">
                      💖 FoundHer
                    </span>
                  </div>

                  <h3 className="mt-3 text-lg md:text-xl font-bold text-white leading-snug">
                    Proud Alumni of{" "}
                    <span className="text-pink-400">{form.collegeName}</span>
                  </h3>

                  <p className="mt-3 text-sm text-gray-300 leading-7">
                    🌸 Verified by my institution as a{" "}
                    <strong>FoundHer Entrepreneur</strong>.
                    <br />
                    🚀 Committed to lifelong learning, leadership and creating
                    meaningful impact.
                    <br />
                    🤝 Dedicated to empowering women, uplifting communities and
                    inspiring future founders.
                  </p>

                  <div className="mt-4 flex flex-wrap gap-2 text-xs">
                    <span className="px-3 py-1 rounded-full bg-pink-600/20 text-pink-300">
                      🎓 Alumni
                    </span>

                    <span className="px-3 py-1 rounded-full bg-purple-600/20 text-purple-300">
                      👩‍💼 Founder
                    </span>

                    <span className="px-3 py-1 rounded-full bg-blue-600/20 text-blue-300">
                      🌍 Social Impact
                    </span>

                    <span className="px-3 py-1 rounded-full bg-green-600/20 text-green-300">
                      💪 Women Empowerment
                    </span>

                    <span className="px-3 py-1 rounded-full bg-amber-600/20 text-amber-300">
                      ⭐ Verified
                    </span>
                  </div>
                </div>
              </div>
            </div>
          )}
          {!form.collegeVerified && (
            <div className="bg-zinc-900 border border-zinc-700 rounded-xl p-5">
              {collegeBadge?.verificationStatus === "Verified" ? (
                <div>
                  <div className="text-lg font-bold text-green-400">
                    ✓ Verified Founder
                  </div>
                  <div className="text-sm mt-2">
                    {collegeBadge.institutionName}
                  </div>
                  <div className="text-xs text-gray-400 mt-1">
                    Verified On:{" "}
                    {new Date(collegeBadge.verifiedOn).toLocaleDateString()}
                  </div>
                </div>
              ) : (
                <div>
                  <p className="text-gray-400 mb-4">
                    You can apply for verification badge here.
                  </p>

                  <div className="grid md:grid-cols-2 gap-4">
                    <div>
                      <label className="text-xs font-semibold block mb-1">
                        Institution Name *
                      </label>
                      <input
                        value={form.collegeName}
                        onChange={(e) =>
                          setForm((prev) => ({
                            ...prev,
                            collegeName: e.target.value,
                          }))
                        }
                        className="w-full border border-zinc-700 rounded-lg p-3 bg-zinc-800"
                        placeholder="College / NGO Name"
                      />
                    </div>

                    <div>
                      <label className="text-xs font-semibold block mb-1">
                        Institution's Think5Whys Code *
                      </label>
                      <input
                        value={form.collegeCode}
                        maxLength={14}
                        onChange={(e) =>
                          setForm((prev) => ({
                            ...prev,
                            collegeCode: e.target.value.trim(),
                          }))
                        }
                        className="w-full border border-zinc-700 rounded-lg p-3 bg-zinc-800 font-mono"
                        placeholder="e.g. TU243BM5850150"
                      />
                      <p className="text-[11px] text-gray-500 mt-1">
                        Ask your college/NGO's Think5Whys admin for their code.
                      </p>
                    </div>

                    <div>
                      <label className="text-xs font-semibold block mb-1">
                        Institution Type
                      </label>
                      <select
                        value={form.institutionType || ""}
                        onChange={(e) =>
                          setForm((prev) => ({
                            ...prev,
                            institutionType: e.target.value,
                          }))
                        }
                        className="w-full border border-zinc-700 rounded-lg px-2 py-1 bg-zinc-800"
                      >
                        <option value="">Select Type</option>
                        <option value="College">College</option>
                        <option value="University">University</option>
                        <option value="School">School</option>
                        <option value="NGO">NGO</option>
                        <option value="Community">Community</option>
                        <option value="Corporate">Corporate</option>
                        <option value="Religious Trust">Religious Trust</option>
                        <option value="SHG">SHG</option>
                        <option value="Women Cell">Women Cell</option>
                        <option value="Incubation Centre">
                          Incubation Centre
                        </option>
                        <option value="Startup Cell">Startup Cell</option>
                        <option value="Skill Development Centre">
                          Skill Development Centre
                        </option>
                        <option value="Other">Other</option>
                      </select>
                    </div>
                  </div>
                  <button
                    onClick={applyForBadge}
                    disabled={
                      !form.collegeName?.trim() ||
                      form.collegeCode?.trim().length !== 14
                    }
                    className="mt-5 bg-pink-700 hover:bg-pink-600 disabled:bg-gray-600 w-full py-3 rounded-lg text-white font-medium transition"
                  >
                    Apply for Verification Badge
                  </button>
                </div>
              )}
            </div>
          )}
        </div>

        <div className="mt-8 border-t pt-6">
          <h3 className="font-bold text-pink-700 mb-4">Public Preview</h3>

          <div className="rounded-xl border overflow-hidden bg-white">
            <div
              className="h-40 bg-cover bg-center"
              style={{
                backgroundImage: form.coverPhoto
                  ? `url(${form.coverPhoto})`
                  : "linear-gradient(to right,#ec4899,#db2777)",
              }}
            />

            <div className="px-5 pb-5">
              <h2 className="text-xl font-bold mt-3">{form.userName}</h2>
              <div className="text-pink-700 font-semibold">
                {form.missionTagline}
              </div>

              <p className="text-sm text-gray-700 mt-3">{form.supportStory}</p>

              <div className="mt-4 flex flex-wrap gap-2">
                {form.supportNeeds.map((item, index) => (
                  <span
                    key={index}
                    className="bg-pink-100 text-pink-700 px-3 py-1 rounded-full text-xs"
                  >
                    {item.type}
                  </span>
                ))}
              </div>

              <div className="mt-5">
                <div className="text-sm">
                  ₹{Number(form.raisedAmount).toLocaleString()} raised of ₹
                  {Number(form.fundraisingGoal).toLocaleString()}
                </div>

                <div className="w-full h-3 bg-gray-200 rounded-full mt-2">
                  <div
                    className="h-3 rounded-full bg-green-600"
                    style={{
                      width: `${
                        form.fundraisingGoal > 0
                          ? (form.raisedAmount * 100) / form.fundraisingGoal
                          : 0
                      }%`,
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        {message && (
          <div className="mb-3 rounded-lg bg-green-100 border border-green-300 text-green-700 p-3 text-sm">
            {message}
          </div>
        )}

        <div className="mt-5 flex items-center gap-3">
          {isExistingProfile && (
            <span className="text-xs text-green-400">
              ✓ Profile already exists
            </span>
          )}

          <button
            onClick={saveProfile}
            disabled={saving || loading}
            className="bg-pink-700 hover:bg-pink-800 disabled:bg-gray-400 text-white w-fit px-5 py-2 rounded-lg flex items-center gap-2"
          >
            <FontAwesomeIcon icon={faSave} />
            {saving
              ? "Saving..."
              : isExistingProfile
                ? "Update Profile"
                : "Create Profile"}
          </button>
        </div>
      </div>

      <div className="mt-4 mb-4 bg-white shadow p-6 rounded-xl">
        <h3 className="text-xl font-semibold text-gray-800 mb-3 flex items-center gap-2">
          <FontAwesomeIcon icon={faFileContract} /> Terms & Conditions
        </h3>
        <ul className="list-disc pl-5 text-sm text-gray-600 space-y-2">
          <li className="text-gray-700 text-xs lg:text-sm">
            Contributions are voluntary and non-refundable. Think5Whys only
            facilitates connections between supporters and women entrepreneurs.
          </li>

          <li className="text-gray-700 text-xs lg:text-sm">
            Funds are intended to help with genuine entrepreneurial needs such
            as product development, branding, equipment, registration,
            marketing, or business growth.
          </li>

          <li className="text-gray-700 text-xs lg:text-sm">
            Supporters may receive updates on progress whenever founders choose
            to share them through the platform.
          </li>
        </ul>
      </div>

      {/* Footer */}
      <footer className="bg-pink-700 text-white py-10 px-4 sm:px-6 md:px-20">
        <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-sm text-gray-100">
            &copy; 2026 Think5Whys Global DeepTech Solutions Private Limited.
            All rights reserved.
          </p>
          <div className="flex space-x-6 mt-4 md:mt-0 text-sm">
            <Link
              to="/about-us"
              className="text-white hover:text-green-400 transition"
            >
              About
            </Link>
            <Link
              to="/privacy-policy"
              className="text-white hover:text-green-400 transition"
            >
              Privacy Policy
            </Link>
            <Link
              to="/terms-of-use"
              className="text-white hover:text-green-400 transition"
            >
              Terms of Use
            </Link>
            <Link
              to="/contact-us"
              className="text-white hover:text-green-400 transition"
            >
              Contact
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default FoundHerMySupportProfile;
